<script>
    /*
    	VerticalAvailableCategories.svelte
    */

    import { onMount } from 'svelte';
    import { fly, fade } from 'svelte/transition';
    import { currentMenuNode, currentMenuLevel } from '../../stores/ResourceMenuStore.js';
    import { hasServiceIds, hasChildrenWithServiceIds } from '../../common/public-search-utils.js';

    // TCARE components
    import VerticalAvailableButton from './VerticalAvailableButton.svelte';

    // SMUI components

    $: childCategoriesWithServices = getChildCategoriesWithServices($currentMenuNode);

    export let onAvailableCatButtonClick;                // pass through to button


    onMount(() => {
        // console.log('AvailableCategories onMount');
        // console.log('$currentMenuNode:');
        // console.log($currentMenuNode);
        // console.log('$currentMenuLevel:');
        // console.log($currentMenuLevel);
    })

    const getChildCategoriesWithServices = (node) => {
        // console.log('AvailableCategories getChildCategoriesWithServices');
        const children = [];
        if (!node) return [];
        if (!node.children) return [];
        for (const child of node.children) {
            if (hasServiceIds(child) ) {
                child.menuLevel = $currentMenuLevel + 1;                        // new 11/17 for ResourcePicker
                children.push(child);
            }
        }
        return children;
    }

</script>

<style>
    .available-categories-wrapper {
        width: 100%;
        margin-top: 10px;
        /* height: 300px; */
        /* overflow: auto; */
        display: flex;
        align-items: flex-start;
        border-radius: 20px;
        /* border: 1px solid green; */
    }

    .available-categories {
        /* height: 300px; */
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        /* border: 1px solid blue; */
    }

    /*
    .label-text {
        margin: 20px 0px 10px 0px;
        font-size: 13px;
        font-weight: 500;
        color: #A075A5;
    }

    .label-text span {
        color: var(--tcui-primary);
        font-weight: bold;
    }
    */


    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

{#if childCategoriesWithServices.length > 0}
    <div class="available-categories-wrapper">
        <div class="categories-slider">
            <div class="available-categories">
                {#each childCategoriesWithServices as category}
                    <!-- only non-selected nodes are available -->
                    {#if !category.isSelected}
                        <VerticalAvailableButton {category} onClick={() => onAvailableCatButtonClick(category)} />
                    {/if}
                {/each}
            </div>
        </div>
    </div>
{/if}


<!-- <div class="categories-slider" in:fly="{{ y: -200, duration: 300 }}" out:fly="{{ y: -200, duration: 300 }}"> -->
